var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRosterShape(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.05005e-07 20.9983C6.66266e-07 31.7911 20.9998 20.9983 20.9998 20.9983C20.9998 20.9983 -2.56256e-07 10.2054 2.05005e-07 20.9983Z",
    fill: "#E55733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 20.9983C42 31.7911 21.0002 20.9983 21.0002 20.9983C21.0002 20.9983 42 10.2054 42 20.9983Z",
    fill: "#E55733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4984 39.6015C19.6371 44.998 20.9983 21.0007 20.9983 21.0007C20.9983 21.0007 1.35973 34.2051 10.4984 39.6015Z",
    fill: "#E55733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5006 2.39842C40.6393 7.79486 21.0007 20.9992 21.0007 20.9992C21.0007 20.9992 22.3619 -2.99802 31.5006 2.39842Z",
    fill: "#E55733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4989 39.6015C22.3603 44.998 20.999 21.0007 20.999 21.0007C20.999 21.0007 40.6376 34.2051 31.4989 39.6015Z",
    fill: "#E55733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5009 2.39842C1.36221 7.79486 21.0008 20.9992 21.0008 20.9992C21.0008 20.9992 19.6395 -2.99802 10.5009 2.39842Z",
    fill: "#E55733"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRosterShape);
export default __webpack_public_path__ + "static/media/roster-shape.5ba694b2e200a8135fd19b822973bf5a.svg";
export { ForwardRef as ReactComponent };